export default __webpack_public_path__ + "static/media/select_arrow.0ee17d5f.svg";